export default __webpack_public_path__ + "static/media/signUpRightImg.662ef79b.png";